import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Skills from '../components/Skills';
import Projects from '../components/Projects';
import CtaBanner from '../components/CtaBanner';
import { useScrollReveal } from '../hooks/useScrollReveal';

function HomePage() {
  useScrollReveal();
  return (
    <main className="page">
      <Hero />
      <Stats />
      <Skills />
      <Projects featured />
      <CtaBanner />
    </main>
  );
}

export default HomePage;
